function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import * as Utility from "../commons/Utility";
import * as UserApi from "../ajax/UserApi";
import * as ProfileApi from "../ajax/ProfileApi";
import IntlMessage from '../commons/Intl';
import { Label, Action, Avatar, Errors, Description, Situations } from '../commons/IntlMessages';
import { ConversionStatuses } from "../enum/ConversionStatuses";
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language);
var rpmLanguage = window.navigator.language.substring(0, 2) === 'ja' ? 'jp' : 'en';
var maxFileSize = 10 * 1024 * 1024; // ユーザーアバター変更モーダル

/**
 * モード
 */

export var Mode;

(function (Mode) {
  /**
   * なし
   */
  Mode[Mode["None"] = 0] = "None";
  /**
   * 更新
   */

  Mode[Mode["Modify"] = 2] = "Modify";
  /**
   * プロフィール
   */

  Mode[Mode["Profile"] = 3] = "Profile";
})(Mode || (Mode = {}));
/**
 * メインコンポーネント
 */


var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);

    switch (props.mode) {
      case Mode.Modify:
        _this.state = {
          Modal: null,
          UserId: _this.props.userId,
          AvatarFileName: _this.props.avatarFileName,
          ConversionStatus: _this.props.conversionStatus,
          IsProcessing: false,
          ErrorMessages: [],
          QueryIntervalId: window.setInterval(_this.onRefreshAsync.bind(_assertThisInitialized(_this)), _this.props.queryRefreshInterval)
        };
        break;

      case Mode.Profile:
        _this.state = {
          Modal: null,
          UserId: _this.props.userId,
          AvatarFileName: _this.props.avatarFileName,
          ConversionStatus: _this.props.conversionStatus,
          IsProcessing: false,
          ErrorMessages: [],
          QueryIntervalId: window.setInterval(_this.onRefreshAsync.bind(_assertThisInitialized(_this)), _this.props.queryRefreshInterval)
        };
        break;

      default:
        throw Error();
    }

    _this.GetThumbnailUrl();

    return _this;
  }

  _createClass(MainComponent, [{
    key: "GetThumbnailUrl",
    value: function GetThumbnailUrl() {
      if (!this.props.userId || !this.props.thumbnailFileName) {
        return;
      }

      if (this.props.mode == Mode.Profile) {
        ProfileApi.GetThumbnail(this.state.UserId, this.props.thumbnailFileName, function (blob) {
          $("#userthumbnailmodaliconframe").css("background-image", 'url(' + window.URL.createObjectURL(blob) + ')');
          var thumbnailFrame = $("#thumbnailframe");
          thumbnailFrame.css("background-image", 'none');
        });
      } else {
        UserApi.GetThumbnail(this.state.UserId, this.props.thumbnailFileName, function (blob) {
          $("#userthumbnailmodaliconframe").css("background-image", 'url(' + window.URL.createObjectURL(blob) + ')');
          var thumbnailFrame = $("#thumbnailframe");
          thumbnailFrame.css("background-image", 'none');
        });
      }
    }
    /**
     * ファイル選択時の処理を行います。
     */

  }, {
    key: "onChangeAbator",
    value: function onChangeAbator(e) {
      if (this.state.Modal == null || !this.props.userId) {
        throw Error();
      }

      this.state.ErrorMessages.length = 0;
      var form = $("#MainForm");
      $.validator.unobtrusive.parse(form);
      form.validate();

      if (form.valid()) {
        if (!this.props.userId || e.target == null) {
          throw Error();
        }

        if (e.target.files == null) {
          return;
        }

        var file = e.target.files.item(0);

        if (file == null) {
          return;
        }

        var fileExtension = Utility.getFileExtension(file.name);

        if (fileExtension == null || !(fileExtension == "fbx" || fileExtension == "glb" || fileExtension == "gltf" || fileExtension == "vrm")) {
          this.state.ErrorMessages.push(intl.format(Errors.InputWrongExtention, {
            extention: ".fbx, .glb, .gltf, .vrm"
          }));
        }

        if (file.size > maxFileSize) {
          this.state.ErrorMessages.push(intl.format(Errors.InputWrongFileSize, {
            size: (maxFileSize / 1024 / 1024).toString() + "MB"
          }));
        }

        if (this.state.ErrorMessages.length != 0) {
          this.setState({
            ErrorMessages: this.state.ErrorMessages
          });
          return;
        }

        this.props.onModify(this.props.userId, file, this.props.updateDateTime);
        this.state.Modal.modal('hide');
      }
    }
    /**
     * ステータス名を取得します。
     *
     * @param status ステータス
     */

  }, {
    key: "getConversionStatusName",
    value: function getConversionStatusName(status) {
      switch (status) {
        case ConversionStatuses.Untreated:
          return intl.format(Situations.Success);

        case ConversionStatuses.Failure:
          return intl.format(Situations.Failure);

        case ConversionStatuses.Processing:
          return intl.format(Situations.Processing);

        case ConversionStatuses.Success:
          return intl.format(Situations.Success);

        case ConversionStatuses.Wait:
          return intl.format(Situations.Wait);

        case ConversionStatuses.NoRequest:
          return "";

        default:
          throw Error();
      }
    }
    /**
     * 「アップロード」ボタン押下時の処理を行います。
     */

  }, {
    key: "onUpload",
    value: function onUpload() {
      var _this2 = this;

      this.state.ErrorMessages.length = 0;
      this.onRefresh(function () {
        if (_this2.state.ConversionStatus != ConversionStatuses.Success && _this2.state.ConversionStatus != ConversionStatuses.Failure && _this2.state.ConversionStatus != ConversionStatuses.NoRequest) {
          _this2.state.ErrorMessages.push(intl.format(Errors.ConversionIsNotComplete));

          _this2.setState({
            ErrorMessages: _this2.state.ErrorMessages
          });

          return;
        }

        $("#Avatar").click();
      });
    }
    /**
     * 「調整」ボタン押下時の処理を行います。
     */

  }, {
    key: "onAdjust",
    value: function onAdjust() {
      var _this3 = this;

      this.state.ErrorMessages.length = 0;

      if (this.state.Modal == null || !this.props.userId) {
        throw Error();
      }

      this.onRefresh(function () {
        var _this3$state$Modal;

        if (_this3.state.ConversionStatus != ConversionStatuses.Success) {
          _this3.state.ErrorMessages.push(intl.format(Errors.ConversionIsNotComplete));

          _this3.setState({
            ErrorMessages: _this3.state.ErrorMessages
          });

          return;
        }

        _this3.props.onAdjust(_this3.props.userId);

        (_this3$state$Modal = _this3.state.Modal) === null || _this3$state$Modal === void 0 ? void 0 : _this3$state$Modal.modal('hide');
      });
    }
    /**
     * 定期的にリフレッシュします。
     */

  }, {
    key: "onRefreshAsync",
    value: function onRefreshAsync() {
      var _this4 = this;

      if (!this.props.userId || !this.props.avatarFileName) {
        return;
      }

      if (this.props.mode == Mode.Profile) {
        ProfileApi.GetAvatarConversionStatus(this.state.UserId, this.state.AvatarFileName, function (model) {
          _this4.setState({
            ConversionStatus: model.ConversionStatus
          });
        });
      } else {
        UserApi.GetAvatarConversionStatus(this.state.UserId, this.state.AvatarFileName, function (model) {
          _this4.setState({
            ConversionStatus: model.ConversionStatus
          });
        });
      }
    }
    /**
     * 「リフレッシュ」ボタン押下時の処理を行います。
     */

  }, {
    key: "onRefresh",
    value: function onRefresh(callback) {
      var _this5 = this;

      if (!this.props.userId || !this.props.avatarFileName) {
        callback();
        return;
      }

      if (this.props.mode == Mode.Profile) {
        ProfileApi.GetAvatarConversionStatus(this.state.UserId, this.state.AvatarFileName, function (model) {
          _this5.setState({
            ConversionStatus: model.ConversionStatus
          });

          callback();
        });
      } else {
        UserApi.GetAvatarConversionStatus(this.state.UserId, this.state.AvatarFileName, function (model) {
          _this5.setState({
            ConversionStatus: model.ConversionStatus
          });

          callback();
        });
      }
    }
    /**
      * 「リセット」ボタン押下時の処理を行います。
      */

  }, {
    key: "onDefault",
    value: function onDefault() {
      var _this6 = this;

      this.state.ErrorMessages.length = 0;

      if (this.state.Modal == null || !this.props.userId) {
        throw Error();
      }

      this.onRefresh(function () {
        var _this6$state$Modal;

        if (_this6.state.ConversionStatus != ConversionStatuses.Success && _this6.state.ConversionStatus != ConversionStatuses.Failure) {
          _this6.state.ErrorMessages.push(intl.format(Errors.ConversionIsNotComplete));

          _this6.setState({
            ErrorMessages: _this6.state.ErrorMessages
          });

          return;
        }

        _this6.props.onDefault(_this6.props.userId, _this6.props.updateDateTime);

        (_this6$state$Modal = _this6.state.Modal) === null || _this6$state$Modal === void 0 ? void 0 : _this6$state$Modal.modal('hide');
      });
    }
    /**
     * アバター作成時の処理を行います。
     */

  }, {
    key: "onCreate",
    value: function onCreate() {
      this.state.ErrorMessages.length = 0;
      var frame = document.getElementById("frame");
      frame.src = "https://whiteroom.readyplayer.me/" + rpmLanguage + "/avatar?frameApi&id=new";
      var dialog = $("#CreateAvatarModal");

      if (dialog) {
        dialog.modal('show');
      }
    }
    /**
     * アバター作成後の処理を行います。
     *
     * @param e イベントデータ
     */

  }, {
    key: "onSubscribe",
    value: function onSubscribe(e) {
      var _e$origin,
          _e$data,
          _this7 = this;

      if (this.state.Modal == null || !this.props.userId) {
        throw Error();
      }

      if (((_e$origin = e.origin) === null || _e$origin === void 0 ? void 0 : _e$origin.toString().indexOf('readyplayer.me')) < 0) {
        return;
      }

      if (((_e$data = e.data) === null || _e$data === void 0 ? void 0 : _e$data.toString().indexOf('models.readyplayer.me')) < 0) {
        return;
      }

      if (this.state.IsProcessing) return;
      this.setState({
        IsProcessing: true
      }, function () {
        if (_this7.state.Modal == null || !_this7.props.userId) {
          throw Error();
        }

        var frame = document.getElementById("frame");
        frame.src += "";
        var dialog = $("#CreateAvatarModal");

        if (dialog) {
          dialog.modal('hide');
        }

        _this7.props.onCreate(_this7.props.userId, e.data, _this7.props.updateDateTime);

        _this7.state.Modal.modal('hide');
      });
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this8 = this;

      var modal = $('#UserAvatarModal');
      this.setState({
        Modal: modal
      });
      modal.modal({
        backdrop: 'static',
        keyboard: false
      }); // ポップアップが完全に非表示になった時のイベント。

      modal.on("hidden.bs.modal", function () {
        _this8.props.onHidden();
      });
      $("form").removeData("validator").removeData("unobtrusiveValidation").off("submit.validate click.validate focusin.validate focusout.validate keyup.validate invalid-form.validate");
      $.validator.unobtrusive.parse("form");
      window.addEventListener('message', this.onSubscribe.bind(this));
    }
    /**
     * コンポーネントが破棄(アンマウント)される前に実行されます。
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('message', this.onSubscribe.bind(this));
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      return [/*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "UserAvatarModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("input", {
        type: "file",
        id: "Avatar",
        name: "Avatar",
        accept: ".fbx,.glb,.gltf,.vrm",
        onChange: this.onChangeAbator.bind(this)
      }), /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, this.state.ErrorMessages.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "validation-summary-errors alert alert-danger"
      }, /*#__PURE__*/React.createElement("ul", null, this.state.ErrorMessages.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          key: i
        }, x);
      }))), /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modalIcon"
      }, /*#__PURE__*/React.createElement("div", {
        id: "userthumbnailmodaliconframe",
        className: "thumbnailicon40frame"
      })), /*#__PURE__*/React.createElement("h3", null, intl.format(Avatar.Title))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-9 mx-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "AvatarFileName"
      }, intl.format(Label.Avatar)), /*#__PURE__*/React.createElement("label", {
        className: "col-9 col-form-label"
      }, this.state.AvatarFileName == null ? intl.format(Avatar.Default) : this.state.AvatarFileName)), !this.props.isDefault && [/*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "ConversionStatus"
      }, intl.format(Label.Status)), /*#__PURE__*/React.createElement("label", {
        className: "col-9 col-form-label"
      }, this.getConversionStatusName(this.state.ConversionStatus)))]), /*#__PURE__*/React.createElement("div", {
        className: "form-group row justify-content-center"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-form-label"
      }, intl.format(Description.InputDescriptionFileSize, {
        size: (maxFileSize / 1024 / 1024).toString() + "MB"
      })))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, this.props.canDelete && this.props.authorityId != 3 && (this.state.ConversionStatus == ConversionStatuses.Success || this.state.ConversionStatus == ConversionStatuses.Untreated || this.state.ConversionStatus == ConversionStatuses.Wait || this.state.ConversionStatus == ConversionStatuses.Processing) && [/*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: this.onCreate.bind(this),
        tabIndex: -1
      }, intl.format(Action.Create)), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-default",
        onClick: this.onUpload.bind(this),
        tabIndex: -1
      }, intl.format(Action.Upload)), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-default",
        onClick: this.onAdjust.bind(this),
        tabIndex: -1
      }, intl.format(Action.Adjust)), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-default",
        onClick: this.onDefault.bind(this),
        tabIndex: -1
      }, intl.format(Action.Delete))], this.props.canDelete && this.props.authorityId != 3 && this.state.ConversionStatus == ConversionStatuses.Failure && [/*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: this.onCreate.bind(this),
        tabIndex: -1
      }, intl.format(Action.Create)), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-default",
        onClick: this.onUpload.bind(this),
        tabIndex: -1
      }, intl.format(Action.Upload)), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-default",
        onClick: this.onDefault.bind(this),
        tabIndex: -1
      }, intl.format(Action.Delete))], (!this.props.canDelete || this.props.authorityId == 3) && (this.state.ConversionStatus == ConversionStatuses.Success || this.state.ConversionStatus == ConversionStatuses.Untreated || this.state.ConversionStatus == ConversionStatuses.Wait || this.state.ConversionStatus == ConversionStatuses.Processing) && [/*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: this.onCreate.bind(this),
        tabIndex: -1
      }, intl.format(Action.Create)), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-default",
        onClick: this.onUpload.bind(this),
        tabIndex: -1
      }, intl.format(Action.Upload)), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-default",
        onClick: this.onAdjust.bind(this),
        tabIndex: -1
      }, intl.format(Action.Adjust))], (!this.props.canDelete || this.props.authorityId == 3) && this.state.ConversionStatus == ConversionStatuses.Failure && [/*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: this.onCreate.bind(this),
        tabIndex: -1
      }, intl.format(Action.Create)), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-default",
        onClick: this.onUpload.bind(this),
        tabIndex: -1
      }, intl.format(Action.Upload))], this.state.ConversionStatus == ConversionStatuses.NoRequest && [/*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: this.onCreate.bind(this),
        tabIndex: -1
      }, intl.format(Action.Create)), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-default",
        onClick: this.onUpload.bind(this),
        tabIndex: -1
      }, intl.format(Action.Upload))])))), /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "CreateAvatarModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body row"
      }, /*#__PURE__*/React.createElement("iframe", {
        id: "frame",
        className: "frame",
        allow: "camera *; microphone *; clipboard-write"
      })))))];
    }
  }]);

  return MainComponent;
}(React.Component);

export { MainComponent as default };